import { inject, Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from "@angular/router";
import { MyExperienceService } from "@core/services/my-experience.service";
import { map } from "rxjs";

@Injectable()
export class MyExperienceResolver implements Resolve<any> {
  private readonly experienceService = inject(MyExperienceService);

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return this.experienceService.getExperienceById(route.params['id']).pipe(
      map(response => response.data)
    );
  }
}